// src/App.js

// Remove useState, useEffect, and useCallback if they are unused
import React from 'react';
import { BrowserRouter as Router, Routes, Route, NavLink } from 'react-router-dom';
import './App.css';
import QuizView from './QuizView';
import ReferenceView from './ReferenceView';

function App() {
  return (
    <Router>
      <div className="App">
        {/* Navigation Bar */}
        <nav>
          <ul>
            <li>
            <NavLink to="/" end className={({ isActive }) => (isActive ? 'active' : '')}>
              Quiz Mode
            </NavLink>
            </li>
            <li>
            <NavLink to="/reference" className={({ isActive }) => (isActive ? 'active' : '')}>
              Reference Mode
            </NavLink>
            </li>
          </ul>
        </nav>

        {/* Route Definitions */}
        <Routes>
          <Route path="/" element={<QuizView />} />
          <Route path="/reference" element={<ReferenceView />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;


